// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="video.VideoCountChart"></bfg-chart>
    </div>
</div>

<installs-table rows="rows" prec="2"></installs-table>
`;
// Exports
module.exports = code;